import styled, {ThemeProps} from 'styled-components';
import {Row} from './../../common/Layouts/Layouts';

import {Theme} from './../../../../theme/types';
import StarIconRating from '../../../../Icons/RatingStarIcon';

export const WrapperDiv = styled(Row)(
  props => `
  width: 70%;
  padding-top: ${props.theme.spacing.base};
  padding-left: ${props.theme.spacing.large};
`,
);

export const ReviewTypeTextWrapper = styled.span(
  props => `
  padding-right: ${props.theme.spacing.small};
  font-size: ${props.theme.font.custom(16)};
`,
);

export const ProgressBarWrapperDiv = styled(Row)(
  props => `
  padding-top: ${props.theme.spacing.custom(3)};
  width: 27.5rem;
`,
);

export const ProgressBarCountWrapper = styled.div(
  props => `
  padding-left: ${props.theme.spacing.small};
  font-size: ${props.theme.font.custom(14)};
  flex-direction: row;
`,
);

export const StarDiv = styled(StarIconRating)(
  props => `
// width:1.4rem;
// height:1.4rem;
// padding-right:${props.theme.spacing.small};
  margin-right: 5px;

  path:nth-of-type(2) {
    fill: ${props.theme.colors.downriver.base}
  }
`,
);
